/**
 * Returns the MIME type for a given file name based on its extension.
 * Shared helper for the new-style file preview system.
 */
export default function getFileMIMEtype(fileName?: string): string | undefined {
  if (!fileName) return undefined
  const ext = fileName.split('.')?.pop()?.toUpperCase()
  if (ext === 'JPEG' || ext === 'JPG') return 'image/jpeg'
  if (ext === 'AVI') return 'video/x-msvideo'
  if (ext === 'MP3') return 'audio/mpeg'
  if (ext === 'MP4') return 'video/mp4'
  if (ext === 'MPEG') return 'video/mpeg'
  if (ext === 'PNG') return 'image/png'
  if (ext === 'PDF') return 'application/pdf'
  if (ext === 'SVG') return 'image/svg+xml'
  return undefined
}
